<script>
import DotCursor from './DotCursor'

export default {
  components: {
    DotCursor
  },
  props: {
    setScroller: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      animations: []
    }
  },
  beforeDestroy() {
    this.animations.forEach((animation) => animation.kill())
  },
  mounted() {
    const $titles = this.$el.querySelectorAll(`.animated-titles-text`)

    $titles.forEach(($title) => {
      $title.innerHTML = $title.textContent.replace(/[\s\S]/g, `<div><div>$&</div></div>`).replace(/\s/g, '&nbsp;')
      $title.parentElement.classList.add(`animated-titles-mounted`)
      $title.classList.add(`animated-titles-mounted`)
    })

    this.$root.$data.gsapCallBacks.push(this.setAnimation)
  },
  methods: {
    setAnimation() {
      if (this.setScroller) {
        this.animations.push(this.$root.gsapScrollTrigger({
          once: true,
          onEnter: this.animate,
          start: `top 85%`,
          trigger: this.$el.querySelector(`.animated-titles-text`)
        }))
      }
    },
    animate() {
      this.$el.querySelectorAll(`div > div`).forEach(($letter, index) => {
        setTimeout(() => {
          $letter.classList.add(`active`)
        }, index * 75);
      })
    } 
  }
}
</script>
